// Single source of truth for deriving a username from an email address, shared by
// the phone registration form, the refauth store-checkout webhook and the customer
// setup script.
//
// SuperLogin sanitises the submitted username with `toLowerCase` before using it as
// the sl-users doc `_id`, but refauth stores the *submitted* string on the customer
// record, its `byUsername` view key and the `coach-` role. Anything that is not
// already lowercase therefore ends up as two different identities for one account,
// so these helpers can only ever emit lowercase.

const USERNAME_BASE_MAX_LENGTH = 10;

/**
 * Lowercase, alphanumeric-only stem taken from an email's local part, capped at 10
 * characters. Callers append their own uniqueness suffix.
 */
export function usernameBaseFromEmail(email: string): string {
    if (typeof email !== "string") {
        return "";
    }
    return email
        .trim()
        .toLowerCase()
        .split("@")[0]
        .replace(/[^0-9a-z]/g, "")
        .slice(0, USERNAME_BASE_MAX_LENGTH);
}

/**
 * Base36 whole seconds, used server-side where there is no username-availability
 * endpoint to retry against.
 */
export function timestampUsernameSuffix(now: number = Date.now()): string {
    return Math.floor(now / 1000).toString(36);
}
